import { Project } from './../models/Project.model';
import { Result } from "./../models/Result.model";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "../shared/wrappers/HttpClient";
import { UrlBuilder } from "../models/url-builder.model";

@Injectable()
export class CostProjectService {
    constructor(private httpClient: HttpClient) {}

    endPoint: String = "/cost/consultant";

    async getAll(queryString) {
        return await this.httpClient.get(`${this.endPoint}?${queryString}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/cost-project.service.ts